export default "__VITE_ASSET__w0s96VWq__"